import type { ConsumerStepId } from './steps';

export const CONSUMER_PATHS = {
  entry: '/clients/:clientId/consumer',
  step: '/clients/:clientId/consumer/:step',
  policyReviewDocument: '/consumer-policy-reviews/:reviewId/documents/:documentIndex',
} as const;

export const RETURN_TO_PARAM = 'returnTo';

export function consumerEntryPath(clientId: string): string {
  return `/clients/${clientId}/consumer`;
}

export function consumerStepPath(
  clientId: string,
  step: ConsumerStepId,
  returnTo?: ConsumerStepId,
): string {
  const path = `${consumerEntryPath(clientId)}/${step}`;
  return returnTo ? `${path}?${RETURN_TO_PARAM}=${returnTo}` : path;
}

/** Guided planning's coverage projection, where a consumer handed over from it goes back to. */
export function guidedProjectionPath(clientId: string): string {
  return `/clients/${clientId}/onboarding/guided-planning/assessment-projection`;
}

/** The results slide just before the guided flow, where its first Back returns to. */
export function insightsSummaryPath(clientId: string): string {
  return `/clients/${clientId}/onboarding/insights-summary`;
}
